import { ChangeDetectionStrategy, Component, ElementRef, input, model, output, Signal, viewChild } from '@angular/core';
import { DsBoxModule, DsModalModule } from '@bmw-ds/components';

import { Customer } from '../../customer/model/customer.model';
import { useI18n } from '../../i18n/services/i18n.service';
import { modalOpenOrClosing } from '../../utils/signal/modalOpenOrClosing';
import { CustomerInformationDialogContainer } from './customer-information-dialog.container';

@Component({
  selector: 'cdf-customer-information-dialog-wrapper',
  imports: [DsModalModule, DsBoxModule, CustomerInformationDialogContainer],
  template: `
    <ds-modal [ds-modal-trigger-for]="modal" [(isModalOpen)]="isModalOpen" #modal [isDismissable]="false">
      <ds-box-header>
        {{ i18n('personalData') }}
      </ds-box-header>
      <ds-box-content spacing="lg">
        @if (openOrClosing()) {
          <cdf-customer-information-dialog-container
            [(saving)]="saving"
            [customer]="customer()"
            [continuouslyValidate]="false"
            [editingIdentityDisabled]="editingIdentityDisabled()"
            [editingEmailDisabled]="editingEmailDisabled()"
            (saveChanges)="saveChanges.emit($event)"
            (closeModal)="closeModal()"
          />
        }
      </ds-box-content>
    </ds-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerInformationDialogWrapper {
  protected readonly i18n = useI18n();
  readonly isModalOpen = model(false);
  readonly saving = model(false);

  readonly customer = input.required<Customer>();
  readonly editingEmailDisabled = input(false);
  readonly editingIdentityDisabled = input(false);

  readonly saveChanges = output<Customer>();

  readonly modal: Signal<ElementRef<HTMLElement>> = viewChild.required('modal', { read: ElementRef });
  protected readonly openOrClosing = modalOpenOrClosing(this.isModalOpen, this.modal);

  protected closeModal() {
    this.isModalOpen.set(false);
  }
}
